module.exports = __webpack_public_path__ + "static/media/lucky-wheel.e2bcf430.png";